export default __webpack_public_path__ + "static/media/noggles.7644bfd0.svg";